
export type Note = {
    title: string,
    description: string,
    type?: 'BUG' | 'FEATURE' | 'UPGRADE'
}

export type VersionNote = {
    version: string,
    notes: Note[]
}

export type VersionNotes = VersionNote[];


export const currentVersion = "0.8.2.6";

export const VersionNotesHistory: VersionNotes = [
    {
        version: "0.8.2.6",
        notes: [
            {
                title: "Pedido confirmação antes de eliminar Obras e Entregas",
                description: "Foi adicionado um pedido de confirmação antes de eliminar Obras e Entregas"
            }
        ]
    },
    {
        version: "0.8.2.5",
        notes: [
            {
                title: "Bug fix Gantt",
                description: "Foi corrigido erro de mau posicionamento de barras máquinas que resultava na sobreposição de várias barras",
                type: 'BUG'
            }
        ]
    },
    {
        version: "0.8.2",
        notes: [
            {
                title: "Upgrades Gantt",
                description: "Barras de máquinas do gantt agora são criadas para cada semana, é também possível eliminar barras Gantt caso pretendido"
            }
        ]
    },
    {
        version: "0.8.1",
        notes: [
            {
                title: "Minimizar peças no display de Obras",
                description: "Agora é possível colapsar as peças"
            },
            {
                title: "Alteração de propriedade de Orçamento a mostrar no display de Obras/ permitir hyperligação",
                description: "Agora é mostrado o número do orçamento e não o nome, adiconalmente é permitido fazer link à página do orçamento clicando no número do orçamento"
            }, {
                title: "Bug fix na submissão de entregas",
                description: "Um erro no backend estava a impedir a submissão de entregas. Foi corrigido",
                type: 'BUG'
            }, {
                title: "Permitir gestão de visibilidade de anexos para obras",
                description: "Agora é possível definir se um anexo é acessível ou não para o chão de fábrica"
            }
        ]
    },

    {
        version: "0.8.0",
        notes: [
            {
                title: "Bug fix cálculo de valor final para orçamento",
                description: "Foi corrigido um bug que fazia com que o valor final de uma peça não fosse calculado corretamente para floats (Valor tem de ser definido com . e não ,)",
                type: 'BUG'
            }, {
                title: "Ocorrência com obra associada",
                description: "Ocorrências agora permitem a associação de uma obra. A associação de uma obra é opcional"
            }, {
                title: "Bug fix em edição de Orçamentos",
                description: "Editar um orçamento gerava um erro. Foi corrigido",
                type: 'BUG'
            }, {
                title: "Eliminar obras e entregas",
                description: "Já é possível eliminar obras e entregas"
            }, {
                title: "Anexos a obras",
                description: "Agora é possível associar anexos a obras"
            }, {
                title: "Bug fix contagem peças obra",
                description: "Foi corrigido um bug que fazia com que a contagem de peças de uma obra não fosse correta",
                type: 'BUG'
            }, {
                title: "Considerar fins de semana no cálculo de duração de uma obra/entrega (Gantt)",
                description: "Cálculo de duração de obras agora considera os fins de semana e incrementa duração caso o algum dia de fim de semana seja considerado na duração inicial da obra/entrega"
            }, {
                title: "Novo tipo de operação - Subcontratação",
                description: "Foi adicionado um novo tipo de operação - Subcontratação. Esta operação pode ser especificada na criação da peça e é externa por default"
            }, {
                title: "Upgrade no Obras display",
                description: "Peças das obras agora aparecem colapsadas, para verificar a informação há um botão que pode ser clicado para expandir a informação"
            }

        ]
    },
    {
        version: "0.7.9",
        notes: [
            {
                title: "Contagem peças em Obras",
                description: "Foi corrigida a lógica para contagemd e peças nas obras (Nº peças x Quantidade de cada peça)"
            },
            {
                title: "Descrição material para Peças",
                description: "Foi corrigida a apresentação do material na tabela de peças assim como no componente de consulta da peça"
            },
            {
                title: "Upgrades no gráfico das despesas",
                description: "Foi melhorada a funcionalidade de arrasto para a legenda do gráfico das despesas. O eixo Y agora também se adapta em função do valor máximo em função dos gráficos filtrados"
            }
        ]
    },
    {
        version: "0.7.8",
        notes: [
            {
                title: "Gráfico despesas",
                description: "Foi adicionado o gráfico de despesas. Apresenta despesas totais e despesas por fornecedor. Os gráficos podem ser filtrados através da legenda apresentada no mesmo"
            },
        ]
    },
    {
        version: "0.7.7",
        notes: [
            {
                title: "Material como entidade",
                description: "Material agora é uma entidade que tem de ser configurada nas configurações, o processo de associar o material a peças orçamentadas e peças de obras \
                é efectuado através da seleção do material da lista criada de materiais"
            },
            {
                title: "Dimensões bloco pós Convencionais",
                description: "Agora é possível (e obrigatório) especificar as dimensões do bloco pós Convencionais de modo a terminar uma peça para a operação de Convencional.\
                É ainda possível editar os dados da peça caso haja algum erro nos valores inicialmente introduzidos"
            }, {
                title: "Desenhos técnicos nas peças",
                description: "Agora é possível associar vários documentos a cada peça de uma obra. Esta informação é depois acessível nos menus do chão de obra"
            }, {
                title: "Alteração código em PDF de Notas encomenda",
                description: "O código associado a notas de encomenda no PDF gerado agora é o código especificado em vez do id"
            }, {
                title: "Folhas de obra",
                description: "Upgrades na estrutura das folhas de obra"
            }
        ]
    },
    {
        version: "0.7.6",
        notes: [
            {
                title: "QR Code picker upgrades",
                description: "QR Code picker agora permite a leitura automática da peça em questão através da folha de obra"
            },
            {
                title: "Upgrades para entrada de material",
                description: "Entrada de material agora utilizada data esperada (retirado da nota de encomenda). Adicionalmente, é possível \
                 especificar uma data de entrega aquando da alteração da conformidade para Conforme/Não conforme. O sistema também associa um\
                  utilizador responsável pela recepção do material"
            },
            {
                title: "Release notes",
                description: "Agora é possível ver as notas de versão ao clicar no botão de versão no menu lateral"
            }
        ]
    }
]
